export default __webpack_public_path__ + "static/highfi-319b346f8dce1cbdede9a241c8ab3abd.png";